module.exports = __webpack_public_path__ + "img/engagement_11.0a9429d1.jpg";